module.exports = "/img/15.3d1c7e.webp";